import React from "react";
import PageWrapper from "./Efax.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import EfaxViewDetails from "components/EFaxInbox/EfaxViewDetails";

const Efax = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.efax"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.efax"
          }
        ]}
      />
      <div className="user-tbl">
        <EfaxViewDetails {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.permissionReducer,
    ...state.themeChanger,
    auth: state.auth
  };
};

export default connect(mapStateToProps, null)(Efax);
